
window.addEventListener('load', function () {
  document.querySelectorAll('.footer-block--menu .footer-block__heading').forEach((heading) => {
    heading.addEventListener('click', function () {
      const parent = this.closest('.footer-block--menu');
      parent.classList.toggle('active');
    });
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   const section = document.querySelector(".icon-with-text-section");

//   // Function to check if the section has reached the top of the viewport
//   function checkSticky() {
//     const rect = section.getBoundingClientRect();

//     if (rect.top <= 0) {
//       section.classList.add("sticky");
//     } else {
//       section.classList.remove("sticky");
//     }
//   }

//   // Check sticky on page load
//   checkSticky();

//   // Check sticky on window scroll
//   window.addEventListener("scroll", checkSticky);
// });





document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('#shopify-section-template--25998464418058__icon_with_text_mYrrVN');
  const sectionOffsetTop = section.offsetTop;

  window.addEventListener('scroll', function () {
    if (window.scrollY >= sectionOffsetTop) {
      section.classList.add('sticky-on-top');
    } else {
      section.classList.remove('sticky-on-top');
    }
  });



  
});

document.addEventListener('DOMContentLoaded', function () {
  const targetElement = document.querySelector('#shopify-section-template--25998464418058__custom_image_with_text_nFEHrd');
  const customCartBtn = document.querySelector('.cstm_mbl_cart_btn');
  const customCartBtn1 = document.querySelector('#shopify-section-template--25998464418058__custom_liquid_igqfAF .section-template--25998464418058__custom_liquid_igqfAF-padding div');
  

  function handleScroll() {
    if (targetElement && customCartBtn1) {
      const rect = targetElement.getBoundingClientRect();

      if (rect.top <= 0 || rect.bottom <= window.innerHeight) {
        // User has reached or scrolled past the top or bottom of the target element
        customCartBtn1.classList.add('active');
      } else {
        // User is still above the target element
        customCartBtn1.classList.remove('active');
      }
    }
  }

  window.addEventListener('scroll', handleScroll);
  handleScroll(); // Run on page load

  // Add click event
  if (customCartBtn) {
    customCartBtn.addEventListener('click', function () {
      const targetBtn = document.querySelector('.product-form[data-section-id="template--25998464418058__main"] button');
      if (targetBtn) {
        targetBtn.click();
      } else {
        console.warn('Target button not found.');
      }
    });
  }
});


